import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';

import { css } from '@flipster/styled-system/css';
import { stack } from '@flipster/styled-system/patterns';

import { editProfileBunja } from '../../../bunja';
import { SocialLinkItem } from './item';
import { ShowBothToPublic } from './show-both-to-public';
import { SocialXSection } from './social-connection/x-section';

export const SocialLink = () => {
  const t = useTranslations();
  const { socialLinkProvidersAtom, showBothToPublicSectionAtom } = useBunja(editProfileBunja);
  const socialLinkProviders = useAtomValue(socialLinkProvidersAtom);
  const showBothToPublicSection = useAtomValue(showBothToPublicSectionAtom);
  return (
    <div className={stack({ gap: 12 })}>
      <p className={css({ textStyle: 'Text/L/Strong', color: 'content.default.level-5' })}>
        {socialLinkProviders.length > 1
          ? t('Autogen_common.r251126.s_Social_links')
          : t('Autogen_common.r251126.s_Social_link')}
      </p>
      <div className={stack({ gap: 24 })}>
        {showBothToPublicSection && <ShowBothToPublic />}
        <div className={stack({ gap: 32 })}>
          {socialLinkProviders.map(({ provider, label }) => (
            <SocialLinkItem key={provider} type={provider} label={label} />
          ))}
        </div>
        <SocialXSection />
      </div>
    </div>
  );
};
